import { primeNgComponents } from '@app/shared/primeng/config/primeng-components';
import { primeNgSemantic } from '@app/shared/primeng/config/primeng-semantic';
import { definePreset, ThemeOptions } from '@primeuix/themes';
import Material from '@primeuix/themes/material';
import { PrimeNGConfigType } from 'primeng/config';

const PrimeNgConfig: PrimeNGConfigType = {
	theme: {
		preset: definePreset(Material, {
			semantic: primeNgSemantic,
			components: primeNgComponents
		}),
		options: <ThemeOptions>{
			cssLayer: {
				name: 'primeng',
				order: 'myknow-base, primeng, primeng-custom, myknow-components'
			},
			darkModeSelector: 'none' // Disable dark mode - we implement custom theming.
		}
	},
	inputStyle: 'filled',
	ripple: true
};

export default PrimeNgConfig;